// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1SDeJ","ranges":"BmiRanges_ranges__2YmaM"};